/** biome-ignore-all lint/security/noDangerouslySetInnerHtml: <explanation> */
import { useCheckLogin } from "@hg/recall-frame"
import { trim } from "lodash"
import React, { useEffect, useRef, useState } from "react"

import Toast from "@/components/Toast"
import { i18n, RecallTextPath } from "@/i18n"
import { errMsgMap } from "@/Topics/Recall/const/errMsg"
import {
    requestTeamJoin,
    requestTeamSearch,
    requestTeamSync,
} from "@/services/activity"
// import { collect } from "@/utils/sdk"
import { showConfirm } from "@/components/Confirm"

import styles from "./index.module.scss"

export const useInviteSubmit = (onSuccess?: () => void) => {
    const checkLogin = useCheckLogin("HG")
    const [ownTeamCode, setOwnTeamCode] = useState<string | null>(null)

    useEffect(() => {
        requestTeamSync().then((res) => {
            if (res.code === 0) setOwnTeamCode(res.data.code)
        })
    }, [])

    // const targetUidRef = useRef<string | null>(null)

    const acceptInvite = async (code: string) => {
        const res = await requestTeamJoin(code)
        if (res.code === 0) {
            return true
        }
        Toast.message(
            i18n.getRecall(
                errMsgMap?.[res.code as keyof typeof errMsgMap] as RecallTextPath,
            ) || res.message || "-",
        )
        return false
    }

    const onSearch = async (code: string) => {
        try {
            const res = await requestTeamSearch(code)
            if (res.code === 0) return res.data
        } catch {}
        return null
    }

    const confirmJoinTeam = async (inviteCode: string) => {
        if (!trim(inviteCode)) return
        const ok = await acceptInvite(trim(inviteCode))
        if (ok) {
            // collect("invite_success", {
            //     invite_code: inviteCode,
            //     inviter_uid: targetUidRef.current,
            // })
            removeParam()
            Toast.message(i18n.getRecall("message.join_success"))
            onSuccess?.()
        }
    }

    const preJoinTeam = async (inviteCode: string) => {
        const loggedIn = await checkLogin()
        if (!loggedIn) return
        if (!trim(inviteCode)) {
            Toast.message(i18n.getRecall("message.code_empty"))
            return
        }
        // collect("click", { target: "invite_accept" })
        const search = await onSearch(trim(inviteCode))
        if (search?.code === ownTeamCode) {
            Toast.message(i18n.getRecall("message.join_myself"))
            return
        }
        if (search) {
            const { captain } = search
            // targetUidRef.current = captainUid
            showConfirm({
                content: (
                    <div
                        className={styles.confirmTo}
                        dangerouslySetInnerHTML={{
                            __html: i18n.getRecall(
                                "record.combine_confirmJoin",
                                {
                                    nickname: captain.nickname || "unknown",
                                },
                            ),
                        }}
                    />
                ),
                onOk: () => {
                    confirmJoinTeam(inviteCode)
                },
            })
        } else {
            Toast.message(i18n.getRecall("message.search_no_team"))
        }
    }

    const removeParam = () => {
        const url = new URL(window.location.href)
        url.searchParams.delete("invite_code")
        window.history.replaceState({}, document.title, url.toString())
    }

    return (inviteCode: string) => {
        preJoinTeam(inviteCode)
    }
}
